export class Grade {
  id: number;
  external_id: string;
  name: string;
  description: string;

  last_updated: string;
}


// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/accounting/grade.ts